var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndexDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#02023b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M341.34,343.54h68.85a23,23,0,0,0,19.35-35.34L270.65,59.71a24.09,24.09,0,0,0-40.59,0l-3.44,5.38h0l-31.76,49.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.81,166a23,23,0,0,0-38.69,0L5.54,410.83a24.1,24.1,0,0,0,20.3,37.08H93l143.92-225.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M495.17,410.83l-28.58-44.69H171.94l-29.63,46.45a23,23,0,0,0,19.36,35.32h313.2A24.1,24.1,0,0,0,495.17,410.83Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "307.35 342.55 250.35 253.41 193.36 342.55 307.35 342.55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndexDark);
export default __webpack_public_path__ + "static/media/indexDark.7d7dcc655a9383f0459ab2932a5a656e.svg";
export { ForwardRef as ReactComponent };